import Box from "@mui/material/Box";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import { cleanUrl, startLoginFlow } from "./authRedux";
import { useAuth } from "react-oidc-context";

const root_ = (theme) => ({
  position: "fixed",
  height: "100%",
  width: "100%",
  backgroundColor: "rgba(255, 255, 255, 0.85)",
  zIndex: theme.zIndex.tooltip + 10,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const card_ = (theme) => ({
  display: "flex",
  flexDirection: "column",
  width: 280,
  maxWidth: 345,
  height: 350,
  maxHeight: 360,
  backgroundColor: "rgba(0, 39, 76, 0.9)",
  padding: "10px 20px",
  "& img:hover": {
    cursor: "pointer",
  },
});

const btnContainer_ = (theme) => ({
  paddingBottom: "30%",
});

const btns_ = (theme) => ({
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  marginTop: "auto",
  "& button": {
    width: "100%",
    marginTop: "10px",
    "&:focus-visible": {
      outline: "3px solid #1976d2",
      outlineOffset: "2px",
    },
  },
});

const notAuthorized_ = (theme) => ({
  color: "red",
  marginTop: "50px",
  fontWeight: "bolder",
  textAlign: "center",
});

export default function LoginDialog() {
  const status = useSelector((state) => state.authReducer.status);
  const user = useSelector((state) => state.authReducer.user);
  const auth = useAuth();

  if (auth.isLoading || user) {
    return null;
  }

  return (
    <Box sx={root_}>
      <Card sx={card_}>
        <CardContent>
          <MGISLogo />
          <NotAuthorized status={status} />
        </CardContent>
        <CardActions sx={[btnContainer_, btns_]}>
          <LoginButton status={status} />
          <RequestAccessButton status={status} />
        </CardActions>
      </Card>
    </Box>
  );
}

function NotAuthorized({ status }) {
  useEffect(() => {
    if (status === "failed") {
      // Clear the anchor to avoid the user possibly bookmarking it.
      cleanUrl();

      // Clear this to avoid redirecting here in the future when this
      // user gets access and logs in successfully.
      window.localStorage.removeItem("hashredirect");
    }
  }, [status]);

  if (status === "failed") {
    return <Box sx={notAuthorized_}>Not Authorized. Please request access</Box>;
  } else {
    return null;
  }
}

function MGISLogo() {
  const portalClicked = () => {
    window.open("https://mgis.med.umich.edu/", "_blank");
  };

  return (
    <CardMedia
      component="img"
      alt="MGIS"
      image="/MGIS-logo.png"
      title="MGIS"
      onClick={portalClicked}
    />
  );
}

function LoginButton({ status }) {
  const auth = useAuth();
  const dispatch = useDispatch();
  const loginClicked = () => {
    dispatch(startLoginFlow(auth));
  };
  const visibilityStyle =
    status === "failed"
      ? { visibility: "hidden" }
      : {
          visibility: "visible",
          minHeight: 44,
          color: "black",
          backgroundColor: "#E0E0E0",
        };

  return (
    <Button
      role="region"
      aria-label="Login"
      variant="contained"
      onClick={loginClicked}
      style={visibilityStyle}
      autoFocus
      disableRipple
    >
      Login
    </Button>
  );
}

const mgisAccessRequestPage =
  "https://docs.google.com/document/d/1q72BEQZkhoSxshTwkOGfD0qWSO-qirRsquYP6v8RUWo/edit?usp=sharing&tab=t.0#heading=h.gid1lrbaf0zz";

function RequestAccessButton({ status }) {
  const requestAccessClicked = () => {
    window.open(mgisAccessRequestPage, "_blank");
  };
  const btnStyle =
    status === "failed"
      ? {
          minHeight: 44,
          marginLeft: "0px",
          color: "black",
          backgroundColor: "#E0E0E0",
        }
      : {
          minHeight: 44,
          color: "rgba(255, 255, 255, 0.75)",
          marginLeft: "0px",
        };

  return (
    <Button
      role="region"
      aria-label="Request Access"
      style={btnStyle}
      size="small"
      variant={status === "failed" ? "contained" : undefined}
      onClick={requestAccessClicked}
      disableRipple
    >
      Request Access
    </Button>
  );
}
